import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BmdCookieService, LoginRedirectService } from '@service';

@Injectable()
export class AuthHttpInterceptor implements HttpInterceptor {
  constructor(
    private cookieService: BmdCookieService,
    private loginRedirect: LoginRedirectService,
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.headers.has('Authorization')) {
      return next.handle(request);
    } else {
      if (!this.cookieService.getDesSession()) {
        this.loginRedirect.goToLogin();
      }
      const requestAuth = request.clone({
        setHeaders: {
          Authorization: this.cookieService.getDesSession(),
        },
      });
      return next.handle(requestAuth);
    }
  }
}
